import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import {BehaviorSubject} from 'rxjs';
import {TreeLinks} from "@signature-it/ngx-entity/models";

@Injectable({
    providedIn: 'root'
})

export class EntityPageService {
    private  _mainEntity;
    public _selectedNodeData;
    public _selectedNode;
    protected _navIndexTree: TreeLinks;
    public _navIndexBreadcrumbs;
    updateMainEntity = new BehaviorSubject(null);
    loadingMainEntity = new BehaviorSubject(null);
    updateSelectedNode = new BehaviorSubject(null);
    urlParams;
    activatedRoute;

    constructor() {}

    set mainEntity(solrResponse) {
        this._mainEntity = solrResponse;
        this.updateMainEntity.next(solrResponse);
    }

    get mainEntity() {
        return this._mainEntity;
    }   
    
    set selectedNode(selectedNode) {
        this._selectedNodeData =  selectedNode?.data;
        this._selectedNode =  selectedNode;
        this.updateSelectedNode.next(true);
    }


    get selectedNode() {
        return this._selectedNode;
    }

    set selectedNodeData(_selectedNodeData) {
        this._selectedNodeData = _selectedNodeData;
    }


    get selectedNodeData() {
        return this._selectedNodeData;
    }

    set navIndexTree(navIndexTree) {
        if(navIndexTree) {
            this._navIndexTree = navIndexTree;
            this._navIndexBreadcrumbs = this._navIndexTree.getNodeBreadcrumbs(this._selectedNode);
        }
        this.updateSelectedNode.next(true);
    }

    get navIndexTree() {
        return this._navIndexTree;
    }
}
